import React from 'react';
import styles from './notification.module.css';
import errorIcon from '../../assets/error-icon.svg';
import successIcon from '../../assets/success.svg';
import { NotificationProps } from '../../types';

const Notification: React.FC<Omit<NotificationProps, 'id'>> = ({ title, message, type }) => {
  const renderMessages = () => {
    if (Array.isArray(message)) {
      return (
        <ul className={styles.messageList}>
          {message.map((msg, index) =>
            index === 0 ? <p key={index}>{msg}</p> : <li key={index}>{msg}</li>,
          )}
        </ul>
      );
    }
    return <p>{message}</p>;
  };

  const renderIcon = () => {
    switch (type) {
      case 'error':
        return (
          <img
            src={errorIcon}
            alt="Error"
          />
        );
      case 'success':
        return (
          <img
            src={successIcon}
            alt="Success"
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className={`${styles.notification} ${styles[type]}`}>
      <div className={styles.icon}>{renderIcon()}</div>
      <div className={styles.content}>
        <strong>{title}</strong>
        {renderMessages()}
      </div>
    </div>
  );
};

export default Notification;
